export default __webpack_public_path__ + "static/media/rarity-rate-kat1.a991cf97.svg";